import { render } from "./PlanSuccess.vue?vue&type=template&id=6c8aea44"
import script from "./PlanSuccess.vue?vue&type=script&lang=js"
export * from "./PlanSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__